import { render, staticRenderFns } from "./UserP2PReviewsFilters.vue?vue&type=template&id=59ac0c69&scoped=true&"
import script from "./UserP2PReviewsFilters.vue?vue&type=script&lang=js&"
export * from "./UserP2PReviewsFilters.vue?vue&type=script&lang=js&"
import style0 from "./UserP2PReviewsFilters.vue?vue&type=style&index=0&id=59ac0c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac0c69",
  null
  
)

export default component.exports